import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=d6cb3ac0&scoped=true&"
import script from "./DataChart.vue?vue&type=script&lang=js&"
export * from "./DataChart.vue?vue&type=script&lang=js&"
import style0 from "./DataChart.vue?vue&type=style&index=0&id=d6cb3ac0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cb3ac0",
  null
  
)

export default component.exports